import React from 'react';
import { Row } from '@amzn/stencil-react-components/layout';
import { Text } from '@amzn/stencil-react-components/text';
import {reSubscribedMessages} from "../localeContent";
import { getLocalePreference } from "../../util/getLocalePreference";

const Headline = Text.withComponent('h1');
const localePreference = getLocalePreference();
const content = JSON.parse(JSON.stringify(reSubscribedMessages))[localePreference];

export default function ResubscribedState() {
  return (
    <div>
      <Row alignItems="center" justifyContent="center">
        <Headline fontSize="T600">{content.headline}</Headline>
      </Row>
      <Row alignItems="center" justifyContent="center" margin="1rem">
        <Text fontSize="T300">
            {content.body1}
        </Text>
      </Row>
    </div>
  );
}
